import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from './CookieConsentContext.jsx';
import { measurementId, setAnalyticsConsent, analyticsPageView } from '../lib/analyticsClient.js';
export default function AnalyticsConsent() {
  const { ready, consent } = useCookieConsent();
  const location = useLocation();
  useEffect(() => {
    if (!measurementId) return;
    setAnalyticsConsent(ready && consent.analytics);
    if (!ready || !consent.analytics) return;
    let second;
    const first = requestAnimationFrame(() => {
      second = requestAnimationFrame(() => analyticsPageView({
        key: location.key, url: window.location.href,
      }));
    });
    return () => { cancelAnimationFrame(first); if (second !== undefined) cancelAnimationFrame(second); };
  }, [ready, consent.analytics, location.pathname, location.search]);
  return null;
}
